/**
 * The runner's transform skip tokens in words (`metrics.skippedReason` of a skipped transform
 * step): `TRANSFORM_SKIP_REASONS` in `runner/steps/transform.ts`, and finalize's
 * `NO_SUCCESSFUL_EXTRACT` (`runner/steps/finalize.ts`). Each phrase completes "the dbt step was
 * skipped because ...". `runner/steps/__tests__/transformSkipReasons.test.ts` fails when the
 * runner writes a token with no phrase here.
 */
export const TRANSFORM_SKIP_REASON_WORDS: Readonly<Record<string, string>> = {
  no_destination_binding: "no destination is set",
  databricks_not_supported: "dbt on Databricks is not supported yet",
  no_snowflake_account: "no Snowflake account is set",
  no_dbt_repo_url: "no dbt repository is connected",
  no_dbt_image: "no dbt image is configured",
  no_enabled_transformations: "no dbt job is enabled",
  no_dbt_selector: "no enabled dbt job has a selector",
  // Round 7: the schedule's "Skip when a source is stale" check (`SOURCES_STALE_SENTENCE`).
  sources_stale: "a source table these models read is past its freshness limit",
  // #1083: finalize skips dbt when no import of the run succeeded (`NO_SUCCESSFUL_EXTRACT_REASON`).
  no_successful_extract: "no import in this run succeeded",
};

/** The phrase for a skip token, or null for none or a token with no phrase (never the token). */
export function transformSkipReasonWord(token: string | null | undefined): string | null {
  if (!token) return null;
  return Object.hasOwn(TRANSFORM_SKIP_REASON_WORDS, token)
    ? (TRANSFORM_SKIP_REASON_WORDS[token] ?? null)
    : null;
}
